import React from "react";
import GOIHeaderSection from "../GOIHeaderSection";
import GOI from "./GOI";
import useGOINode from "./useGOINode";
import GOIRenderTabContent from "../GOIRenderTabContent";
import useObjectInput from "../../../hooks/useObjectInput";

// its renders a node within a hierarchical data structure,
// allows editing and saving of node data along with handling different views or modes of the node.
const GOINode = ({
  inputData, // node it is supposed to render
  savingParentValue, // will be true if parent save data request is in progress
  hideTitles = false, // to show / hide the titles of the node
  parentCb, // callback to inform the parent if the changes were saved successfully
  cancelAllowed = true, // in some cases we dont allow the user to cancel the editing
  editMode, // to keep track of the editing status
}) => {
  // local state
  const {
    activeTab,
    handleSaveBtnClick,
    handleValueChange,
    isSaving,
    onStateChange,
  } = useGOINode(inputData, parentCb, editMode);

  const { idValuePair, id } = useObjectInput();

  // get the value of the input
  const value = idValuePair[inputData.id];

  // user can only cancel the editing if the saved value is not null
  const isCancelAllowed = () =>
    cancelAllowed &&
    editMode &&
    inputData.hasOwnProperty("savedValue") &&
    inputData.savedValue !== null &&
    inputData.savedValue !== "";

  const knownField = [
    "File",
    "Integer",
    "Float",
    "String",
    "Time",
    "Date",
    "Boolean",
    "SingleChoice",
    "Timestamp",
  ].includes(inputData.class);

  return (
    <div
      className={`${
        id === inputData.id ? "border-none" : hideTitles ? "mx-15" : "m-15"
      } generated-object-input `}
    >
      {/* header section: contains the tabs */}
      <GOIHeaderSection
        activeTab={activeTab}
        setActiveTab={(value) => onStateChange("activeTab", value)}
        saving={isSaving || savingParentValue}
        editMode={knownField ? editMode : true}
        data={inputData}
        handleSaveBtnClick={handleSaveBtnClick}
        showSwitchView={false}
        hideTitles={hideTitles}
        cancelAllowed={knownField && isCancelAllowed()}
        handleValueChange={handleValueChange}
      />

      {/* tab content viewer */}
      <GOIRenderTabContent activeTab={activeTab} data={inputData} />
      <div className={activeTab && "goi-input-field-wrapper-border-top"}>
        <GOI
          editMode={editMode}
          inputData={inputData}
          value={value}
          key={`${inputData.id}-${editMode}`}
        />
      </div>
    </div>
  );
};

export default GOINode;
